import format from 'date-fns/format';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

export interface Props {
  date: Date;
  disabled: boolean;
  setDate: (date: string) => void;
}

const dateToLocalDate = (date: Date) => format(date, 'yyyy-MM-dd');

function DateInput({ setDate, date, disabled }: Props) {
  return (
    <div className="flex flex-col mr-2">
      <label className="font-semibold text-sm">
        <T kind="Date" />
      </label>
      <input
        type="date"
        value={dateToLocalDate(date)}
        onChange={(e) => setDate(e.target.value)}
        name="send-date"
        className="rounded border-gray-300 w-36 disabled:bg-gray-50 disabled:text-gray-400"
        min={dateToLocalDate(new Date())}
        disabled={disabled}
      />
    </div>
  );
}

export default observer(DateInput);
